import { render, staticRenderFns } from "./AnotherUserAccount.vue?vue&type=template&id=66845818&scoped=true"
import script from "./AnotherUserAccount.vue?vue&type=script&lang=js"
export * from "./AnotherUserAccount.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "66845818",
  null
  
)

export default component.exports